import "./../styles/main.scss";
import $ from "jquery";
import inView from "in-view";
import L from "leaflet";
import "leaflet-providers";
import Siema from "siema";
import Timer from "./helpers/Timer";
require("./CookieConsent");
var SimpleLightbox = require('simple-lightbox');
$(document).ready(function () {
    new SimpleLightbox({ elements: '#gallery a' });
    $("body").on("click", "a[href^='#goto-']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("goto-", "");
        var posY = $(node).offset().top - $("#main-header").height();
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    // $('*[data-appear]').css('opacity',0);
    inView.offset(100);
    inView('*[data-appear]')
        .on('enter', function (el) {
        if ($(el).attr('data-appearlater') === void 0)
            $(el).addClass('animated ' + $(el).attr('data-appear'));
    });
    $('*[data-appearlater]').each(function (i, e) {
        var $this = $(e);
        setTimeout(function () {
            $this.addClass('animated ' + $this.attr('data-appear'));
        }, 150 * i);
    });
    $('.Team.person > div').on("click", function (e) {
        $(e.currentTarget).children(".text").fadeToggle(400);
    });
    if ($("#map").length) {
        $('.simpleLightbox').simpleLightbox({
            nav: false
        });
        var map = L.map('map');
        var items_1 = {};
        var blueIcon_1 = new L.Icon({
            iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
            shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        });
        var greyIcon_1 = new L.Icon({
            iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png',
            shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        });
        if ($("#map").hasClass("contact-page")) {
            map.setView([50.840860, 4.428340], 14);
            L
                .marker([50.840860, 4.428340], { icon: blueIcon_1 })
                .addTo(map);
        }
        else {
            map.setView([50.838589, 4.417500], 12);
        }
        map.scrollWheelZoom.disable();
        L.tileLayer.provider("CartoDB.Positron").addTo(map);
        map.touchZoom.disable();
        $('.cities .list').on("click", "a:not(.active)", function (e) {
            e.preventDefault();
            var elm = $(e.currentTarget);
            var id = elm.data("id");
            $('.cities .list a.active').removeClass("active");
            elm.addClass("active");
            $('.cities .text .active').removeClass('active');
            $('.cities .text').find("*[data-id='" + id + "']").addClass("active");
            // $('.cities .text .active').fadeOut(function() {
            //     $('.cities .text').find("*[data-id='"+ id +"']").addClass("active");
            // }, 500);
        });
        $(".cities-wrapper .city").each(function (i, e) {
            var item = $(e);
            if (item.data("lat") !== void 0 && item.data("lng") !== void 0) {
                var str = '';
                var options = { icon: greyIcon_1 };
                if (item.data("picture-high") !== void 0) {
                    str = "<a href=\"" + item.data("picture-high") + "\" class='reference-" + i + "'><img src=\"" + item.data("picture-low") + "\" /></a>";
                    options = { icon: blueIcon_1 };
                }
                L
                    .marker([item.data("lat"), item.data("lng")], options)
                    .bindPopup("\n                        " + str + "\n                        <span><strong>" + item.data("name") + "</strong><br>" + item.data("description") + "</span>\n                    ")
                    .addTo(map);
                if (item.data("picture-high") !== void 0) {
                    $("body").on("click", ".reference-" + i, function (e) {
                        e.preventDefault();
                        if (items_1[i] === void 0) {
                            var a = $('body .reference-' + i).simpleLightbox();
                        }
                    });
                }
            }
        });
    }
    function adaptHoveredImg() {
        $('img.hover').each(function (i, e) {
            var nImg = $(e).next('img');
            $(e).css({
                height: nImg.height(),
                width: nImg.width()
            });
        });
    }
    adaptHoveredImg();
    $(window).resize(function () { adaptHoveredImg(); });
    var sliderNode = $('.slider');
    // const interludeSliderNode = $('#interlude .slider');
    if (sliderNode.length) {
        var sliderTimer_1 = new Timer(function () {
            slider_1.next();
        }, 5000);
        var slider_1 = new Siema({
            selector: '.slider .siema',
            loop: true,
            duration: 400,
            onInit: function () {
                sliderNode.find('.navigation').children(":nth-child(1)").addClass("active");
                sliderTimer_1.start();
            },
            onChange: function () {
                var navigation = sliderNode.find(".navigation");
                navigation.find(".active").removeClass("active");
                navigation.children(":nth-child(" + (this.currentSlide + 1) + ")").addClass("active");
            }
        });
        sliderNode.find(".navigation").on("click", "span", function (e) {
            sliderTimer_1.reset(5000);
            slider_1.goTo($(e.currentTarget).index());
        });
        sliderNode.on("click", ".control a", function (e) {
            var elm = $(e.currentTarget);
            sliderTimer_1.reset(5000);
            if (elm.parent().hasClass("left")) {
                slider_1.prev();
            }
            else {
                slider_1.next();
            }
        });
    }
});
